/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-01-31 09:23:00
 *
 *******************************************************/
//@flow
//
export const selectStyle = (updateStyle = {}) => {
  const { menuPortal = {} } = updateStyle;
  const style = {
    menuPortal: base => ({ ...base, zIndex: 9999, ...menuPortal }),
    menu: (provided, state) => ({ ...provided, zIndex: 600 }),
    option: (provided, state) => ({
      ...provided,
      margin: '4px 10px',
      width: 'calc(100% - 20px)',
      borderRadius: '4px',
      color: 'var(--p-text)',
      '&:hover': {
        background: '#F6F6F7'
      },
      [state.isSelected ? 'backgroundColor' : '']: 'var(--p-surface-selected)'
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? 'var(--p-text-disabled)' : 'var(--p-text)'
    }),
    container: (provided, state) => {
      const focusStyle = state.isFocused
        ? {
            borderColor: 'var(--p-focused) !important',
            boxShadow: '0 0 0 1px var(--p-focused) !important',
            borderRadius: '4px'
          }
        : {};
      return {
        ...provided,
        ...focusStyle
      };
    },
    control: (provided, state) => {
      const focusStyle = state.isFocused
        ? {
            borderColor: 'var(--p-focused) !important',
            boxShadow: '0 0 0 1px var(--p-focused) !important'
          }
        : {};
      return {
        ...provided,
        ...focusStyle,
        minHeight: '36px'
      };
    },
    placeholder: (provided, state) => ({ ...provided, color: '#637381' }),
    multiValue: (provided, state) => ({
      ...provided,
      backgroundColor: '#B4E0FA',
      zIndex: 500,
      cursor: 'grab',
      '&:active': {
        cursor: 'grabbing'
      }
    }),
    multiValueLabel: (provided, state) => ({
      ...provided,
      color: '#084E8A',
      paddingLeft: '3px',
      paddingRight: '6px',
      order: 1,
      fontWeight: 500,
      fontSize: '12px',
      height: '26px',
      display: 'flex',
      lineHeight: '19px'
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      color: '#084E8A',
      paddingLeft: '6px',
      paddingRight: '1px',
      order: 0,
      '&:hover': {
        backgroundColor: '#B4E0FA',
        color: '#084E8A'
      }
    }),
    // dropdownIndicator: (provided, state) => ({
    //   ...provided,
    //   // display: 'none',
    //   padding: '0 8px',
    //   ...dropdownIndicator
    // }),
    indicatorSeparator: (provided, state) => ({ ...provided, display: 'none' })
    // clearIndicator: (provided, state) => ({ ...provided, display: 'none' })
  };

  return style;
};
